import { BotData } from "@shared/types";
import { useContext, useEffect, useState } from "react";
import {
  BaseBotFormValues,
  ToggleField,
} from "@shared/features/bots/BotForm/common/types";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { useMergeBotValues } from "@shared/features/bots/BotForm/common/hooks";

interface useBulkEditBotFormValuesProps {
  botsData?: BotData[];
}

const useBulkEditBotFormValues = ({
  botsData,
}: useBulkEditBotFormValuesProps) => {
  const { initialized: botFormInitialized, setCheckedFields } =
    useContext(BotFormContext)!;
  const [originalBotValues, setOriginalBotValues] = useState<
    BaseBotFormValues | undefined
  >();
  const [originalCheckedFields, setOriginalCheckedFields] =
    useState<Set<ToggleField>>();
  const [initialized, setInitialized] = useState(false);
  const { getMergedBotsData, isReady } = useMergeBotValues();

  const initializeData = () => {
    const [botValues, checkedFields] = getMergedBotsData(botsData);
    setOriginalBotValues(botValues);
    setOriginalCheckedFields(checkedFields);
    setCheckedFields(checkedFields);
    setInitialized(true);
  };

  useEffect(() => {
    if (botsData && isReady && botFormInitialized) {
      initializeData();
    }
  }, [botsData, isReady, botFormInitialized]);

  return {
    initialized,
    originalBotValues,
    originalCheckedFields,
  };
};

export default useBulkEditBotFormValues;
